<script>
export default {
  props: {
    clr: {
      default: "#768391"
    }
  }
};
</script>
<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.54993 5.23406C8.59359 2.5313 13.1406 1.94306 16.8564 4.08841C19.7303 5.74761 21.4367 8.65484 21.6836 11.7318L20.4005 10.1764L18.6377 11.6307L21.7554 15.41L23.2756 17.2528L23.7563 14.9127C24.7671 9.99022 22.5928 4.76132 17.9991 2.10921C13.4056 -0.542902 7.79001 0.188474 4.03245 3.52518L5.54993 5.23406ZM2.24456 9.59006L0.72434 7.74731L0.243768 10.0874C-0.767125 15.0098 1.40726 20.2388 6.00085 22.8909C10.5945 25.543 16.21 24.8116 19.9675 21.4748L18.45 19.7661C15.4065 22.4688 10.8595 23.057 7.14354 20.9117C4.26973 19.2525 2.56336 16.3453 2.31634 13.2683L3.59948 14.8237L5.36238 13.3694L2.24456 9.59006ZM10.2859 12.5002C10.2859 11.5535 11.0534 10.7862 12 10.7862C12.9466 10.7862 13.714 11.5535 13.714 12.5002C13.714 13.4468 12.9466 14.2143 12 14.2143C11.0534 14.2143 10.2859 13.4468 10.2859 12.5002ZM12 8.50075C9.79115 8.50075 8.00057 10.2914 8.00057 12.5002C8.00057 14.7091 9.79115 16.4997 12 16.4997C14.2088 16.4997 15.9994 14.7091 15.9994 12.5002C15.9994 10.2914 14.2088 8.50075 12 8.50075Z"
      :fill="clr"
    />
  </svg>
</template>
